import PostView from './post-view'

export default PostView
